module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ReportList'
      }
    }
  }, [_vm._v("Raporty")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(!_vm.loading) ? _c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    ref: "tabs",
    attrs: {
      "card": "",
      "lazy": true
    }
  }, [_vm._l((_vm.currencyTypes), function(item) {
    return _c('b-tab', {
      attrs: {
        "title": 'Obroty (' + item.name + ')'
      }
    }, [_c('ReportSales', {
      attrs: {
        "currency": item
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.currencyTypes), function(item) {
    return _c('b-tab', {
      attrs: {
        "title": 'Wierzytelności (' + item.name + ')'
      }
    }, [_c('ReportDebts', {
      attrs: {
        "currency": item
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.currencyTypes), function(item) {
    return _c('b-tab', {
      attrs: {
        "title": 'Sprzedaż (' + item.name + ')'
      }
    }, [_c('ReportInvoice', {
      attrs: {
        "currency": item
      }
    })], 1)
  })], 2)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31395d07","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/List.vue
// module id = 803
// module chunks = 0